import { Box, Grid, makeStyles, Typography } from '@material-ui/core'
import React, { useEffect } from 'react'
import colors from '../../../assets/colors'
import { CustomSwitch } from '../../../components/ui/custom-switch'
import { useDispatch, useSelector } from 'react-redux'
import { changeConfigStatus, fetchLaundryConfigs } from '../SettingsActions'
import {
  fetchAuthenticatedUser,
  revalidateAuthenticatedUser,
} from '../../auth/AuthActions'
import { usePermissions } from '../../../hooks/usePermission'

const useStyles = makeStyles({
  configBox: {
    border: '1px solid ',
    borderColor: colors.graylight,
    borderRadius: '12px',
    padding: '12px 24px',
    maxWidth: '300px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    height: '100%',
  },
  configBoxHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
})

export const Configs = ({ collectedItems = false }) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const laundryConfigs = useSelector(state => state.configs.laundryConfigs)
  const permissionUser = useSelector(state => state.auth.permissionUser)

  const { canUpdate } = usePermissions()

  const fetchConfig = () => {
    dispatch(
      fetchLaundryConfigs(
        collectedItems
          ? { name: 'collected-items' }
          : { name_not_like: 'collected-items' }
      )
    )
  }

  const handleChangeConfig = async (laundryConfigId, isActive) => {
    await dispatch(changeConfigStatus(laundryConfigId, isActive))
    await dispatch(revalidateAuthenticatedUser())
    fetchConfig()
  }

  useEffect(() => {
    fetchConfig()
  }, [])

  return (
    <Grid container spacing={4}>
      {laundryConfigs?.map((config, index) => (
        <Grid item key={`config-box-${index}`}>
          <Box className={classes.configBox}>
            <Box className={classes.configBoxHeader}>
              <Typography
                style={{ fontWeight: 'bold', textTransform: 'capitalize' }}
              >
                {config?.display_name}
              </Typography>
              {canUpdate('configuracoes', permissionUser) && (
                <CustomSwitch
                  checked={config?.is_active}
                  onClick={() =>
                    handleChangeConfig(config?.id, !config?.is_active)
                  }
                />
              )}
            </Box>
            <Typography style={{ color: colors.textGray }}>
              {config?.description}
            </Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  )
}
